import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { get } from '../../utils/api'
import { getQueryString } from '../../utils/queryString'
import { getObservationsQueryParams } from '../Observations/getObservationsQueryParams'
import { ObservationsParams, ObservationsResult } from '../Observations/types'
import useStyles from './DeselectAllButton.styles'
import { Observation } from './types'

type DeselectAllButtonProps = {
  selected: Observation[]
  setSelected: (selected: Observation[]) => void
  params: ObservationsParams
  disabled?: boolean
  onDeselected?: (deselected: Observation[]) => void
  showCount?: boolean
}

export const DeselectAllButton = ({
  selected,
  setSelected,
  params,
  disabled = false,
  onDeselected,
  showCount = false,
}: DeselectAllButtonProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [isLoading, setLoading] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleDeselectFiltered = () => {
    setLoading(true)
    return get<ObservationsResult>(
      `/observations/?${getQueryString({
        ...getObservationsQueryParams(params),
        offset: 0,
        limit: 20000,
        mode: 'no_image_data',
      })}`
    )
      .then((response) => response?.results || [])
      .then((filteredObs) => {
        const filteredIds = new Set(filteredObs.map((obs) => obs.id))
        const remaining = selected.filter((obs) => !filteredIds.has(obs.id))
        setSelected(remaining)
        onDeselected?.(filteredObs)
      })
      .finally(() => setLoading(false))
  }

  const label = showCount
    ? t('Deselect all ({{count}})', { count: selected.length })
    : t('Deselect all')

  return (
    <div
      className={classes.wrapper}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Button
        onClick={() => handleDeselectFiltered()}
        label={label}
        buttonType="button"
        type="default"
        loading={isLoading}
        disabled={disabled}
      />
      {showTooltip && (
        <div className={classes.tooltip}>
          <FontAwesomeIcon icon={faCircleInfo} />
          {t('Deselection takes into account any applied filters')}
        </div>
      )}
    </div>
  )
}
